import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { License, LicenseDto } from '@app/store/shared/models';
import { LicenseValue, LicenseValueDto, UpgradeLicenseValue, UpgradeLicenseValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getLicense(id: string): Observable<License> {
        return this.httpClient.get<LicenseDto>(`licenses/${id}`).pipe(map((dto) => new License(dto)));
    }

    updateLicense(id: string, value: LicenseValue): Observable<License> {
        const dto = new LicenseValueDto(value);

        return this.httpClient.patch<LicenseDto>(`licenses/${id}`, dto).pipe(map((response) => new License(response)));
    }

    upgradeLicense(id: string, value: UpgradeLicenseValue): Observable<License> {
        const dto = new UpgradeLicenseValueDto(value);

        return this.httpClient.post<LicenseDto>(`licenses/${id}/upgrade`, dto).pipe(map((response) => new License(response)));
    }
}
